import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import PlanCompatibilityMessage from 'marketplace-ui-common/compatibility/components/PlanCompatibilityMessage';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import useRequiredPlansForFeatures from '../../hooks/useRequiredPlansForFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlanCompatibility = ({
  appContext,
  features,
  integrationFeatures,
  installability,
  isOpsHubListing,
  onOpenFeatureCompatibilityModal,
  tiers,
  trackInteraction
}) => {
  const {
    hubInstallable,
    nonTrialHubInstallable
  } = installability || {};
  const {
    requiredPlans,
    compatibilityLoading,
    compatibilityError
  } = useRequiredPlansForFeatures({
    appContext: appContext === 'admin-preview' ? 'public' : appContext,
    integrationFeatures: integrationFeatures || [],
    features: features || []
  });
  const featureCompatibilityStatus = getDataFetchingClientRequestState(compatibilityError, compatibilityLoading);
  const compatibilityType = useMemo(() => {
    if (!isOpsHubListing || !requiredPlans) {
      return 'COMPATIBLE_ALL';
    }
    const missingRequiredPlans = requiredPlans.filter(plan => !!plan);
    if (missingRequiredPlans.length === 0) {
      return 'COMPATIBLE_ALL';
    } else if (features && missingRequiredPlans.length <= features.length / 2) {
      return 'COMPATIBLE_MOST';
    } else if (integrationFeatures && missingRequiredPlans.length <= integrationFeatures.length / 2) {
      return 'COMPATIBLE_MOST';
    } else if (!hubInstallable) {
      return 'COMPATIBLE_NONE';
    } else {
      return 'COMPATIBLE_SOME';
    }
  }, [hubInstallable, requiredPlans, isOpsHubListing, features, integrationFeatures]);
  const opsHubLoadingStatus = isOpsHubListing ? featureCompatibilityStatus : RequestState.SUCCEEDED;
  const pageLoadingStatus = !installability ? RequestState.PENDING : opsHubLoadingStatus;
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: pageLoadingStatus,
    children: /*#__PURE__*/_jsx(PlanCompatibilityMessage, {
      appContext: appContext === 'admin-preview' ? 'public' : appContext,
      compatibilityType: compatibilityType,
      helpText: compatibilityType !== 'COMPATIBLE_ALL' ? /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.compatibilityDisclaimer"
        })
      }) : undefined,
      nonTrialHubInstallable: nonTrialHubInstallable,
      onTrackInteraction: trackInteraction,
      onFeaturesLinkClick: () => onOpenFeatureCompatibilityModal(),
      showCompatiblePlansLink: !isOpsHubListing,
      tiers: tiers
    })
  });
};